/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media (min-width:600px){.info-seats[_ngcontent-%COMP%]{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}}.info-seats[_ngcontent-%COMP%]   .top-gap[_ngcontent-%COMP%]{margin-top:1rem}@media (max-width:599px){.info-seats[_ngcontent-%COMP%]   .top-gap[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{display:block}.info-seats[_ngcontent-%COMP%]   .top-gap[_ngcontent-%COMP%]   .left-gap[_ngcontent-%COMP%]{margin-left:0}}"];
export { styles as styles };
